<template>
  <div id="app" class="show-flex-box-c">
    <div class="contain-box">
      <router-view />
    </div>
  </div>
</template>

<script>

import Course from "./views/Course/index.vue";

export default {
  name: "App"
};
</script>
<style lang="less" scoped>
.title-bar {
  width: 100%;
  height: 0.44rem;
  color: #23262B;
  font-size: 0.18rem;
  line-height: 0.44rem;
  font-weight: 500;
  text-align: center;
}
.contain-box {
  overflow: scroll;
  width: 100%;
  height: 100%;
  flex-grow: 1;
}
</style>
<style>
html,
body {
  height: 100%;
  width: 100%;
}
#app {
  height: 100%;
  width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/App.vue